export interface PositionableTextMarker {
	height: number;
	top: number;
	adjustVisual: () => void;
}

interface VerticalRect {
	top: number;
	height?: number;
}

/** Converts the action bar's screen position into the marker canvas coordinate space. */
export function getUsableTextMarkerBottom(
	markerCanvasRect: VerticalRect,
	actionBarRect: VerticalRect,
	targetHeight: number,
	gap: number
): number {
	if (
		!Number.isFinite(markerCanvasRect.top) ||
		!Number.isFinite(markerCanvasRect.height) ||
		(markerCanvasRect.height as number) <= 0 ||
		!Number.isFinite(actionBarRect.top) ||
		!Number.isFinite(targetHeight) ||
		targetHeight <= 0
	) {
		return targetHeight;
	}

	const canvasHeight = markerCanvasRect.height as number;
	const usableScreenHeight = Math.min(canvasHeight, Math.max(0, actionBarRect.top - gap - markerCanvasRect.top));
	return (usableScreenHeight / canvasHeight) * targetHeight;
}

/** Moves an expanding text marker upward so its lower edge stays above the usable bottom boundary. */
export function keepTextMarkerWithinTarget(marker: PositionableTextMarker, maximumBottom: number | undefined): void {
	if (!Number.isFinite(maximumBottom) || !Number.isFinite(marker.height) || !Number.isFinite(marker.top)) return;

	const maximumTop = Math.max(0, (maximumBottom as number) - marker.height);
	const constrainedTop = Math.min(Math.max(0, marker.top), maximumTop);
	if (constrainedTop !== marker.top) {
		marker.top = constrainedTop;
		marker.adjustVisual();
	}
}
